import { includes, endsWith, find } from 'lodash';
import { history } from 'constants/router';

export class RoutingSessionStateModel {
  
  _visitedPagesPaths = [];
  
  constructor() {
    this.removeHistoryListener = history.listen(this._handleRouteChange);
  }
  
  hasVisited(path) {
    return Boolean(
      find(this._visitedPagesPaths, visitedPath => endsWith(visitedPath, path))
    );
  }
  
  removeHistoryListener;
  
  _handleRouteChange = (location) => {
    const path = location.pathname;
    if (!includes(this._visitedPagesPaths, path)) {
      this._visitedPagesPaths.push(path);
    }
  }
  
}
